var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"two-columns gutter-lg mb body"},[_vm._t("fullWidth"),_vm._v(" "),_c('div',{staticClass:"flex-container"},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._t("right")],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-066b81aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TwoColumns.vue
// module id = null
// module chunks = 